import { boolean, number, object, string } from 'yup';

import { constants as appClientConstants, core as appClientCore } from '@edf-pkg/app-client';

import client from '$app-web/core/client';

const requestSchema = object().shape({
    grant_type: string().required(),
    scope: string().default(appClientConstants.AUTHENTICATION_SCOPES.ALL).required(),
    client_id: string().default(appClientConstants.AUTHENTICATION_CLIENT_IDS.WEB).required(),
    username: string(),
    password: string(),
    refresh_token: string(),
});

const responseSchema = object().shape({
    access_token: string().required(),
    refresh_token: string().required(),
    expires_in: number().required(),
    revoked_deletion: boolean().nullable(),
});

export const useFetchAuthenticationTokens = client.registerEndpoint('POST api/fetch-authentication-tokens', `/v1/auth/token/`, {
    responseSchema,
    requestSchema,
    mutate: true,
    customErrorsOrMapper: {
        [appClientCore.ERROR_CODES.INVALID_TOKEN]: (t, error) => error.errorMessage,
        [appClientCore.ERROR_CODES.UNAUTHORIZED_OR_INACTIVE]: (t) => t('pdash:login_failed_invalid_username_password'),
    },
});
